/**
 * Client Kickoff Questionnaire fill-out links are funneled through splash
 * (main.js's loadSplash) — the one unauth landing mvvLegit allows in every
 * auth state — same technique as invite links (see inviteLink.js). Whether
 * the current page IS a questionnaire landing is decided by ?qr=&token= in
 * the query string, not the URL hash — the hash stays #/splash the whole
 * time. Uses `qr` rather than `uid` specifically so an invite link and a
 * questionnaire link are never ambiguous if somehow both params were present.
 *
 * @param {string} [search] - defaults to window.location.search
 * @returns {boolean}
 */
export function isQuestionnaireLink(search = window.location.search) {
  const params = new URLSearchParams(search || '');
  return !!(params.get('qr') && params.get('token'));
}

/**
 * @param {string} [search] - defaults to window.location.search
 * @returns {{guid: string, token: string}|null}
 */
export function getQuestionnaireLinkParams(search = window.location.search) {
  const params = new URLSearchParams(search || '');
  const guid = params.get('qr');
  const token = params.get('token');
  return guid && token ? { guid, token } : null;
}
